import styled from "styled-components";

export const Container = styled.div`
  margin-top: 20px;
`;

export const PedidoContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  line-height: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;

export const PedidoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const PedidoId = styled.div`
  font-size: 18px;
  font-weight: bold;
`;
export const PedidoStatus = styled.span`
  font-size: 14px;
  color: #4caf50;
  font-weight: bold;
`;
export const PedidoBody = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
`;
export const PedidoData = styled.span`
  font-size: 14px;
  color: #aeaeae;
`;
export const PedidoValor = styled.span`
  font-size: 14px;
  color: #555;
  gap: 5px;
  display: flex;
  align-items: center;
  font-weight: bold;
`;
export const PedidoItens = styled.span`
  font-size: 14px;
  color: #555;
`;

export const DetalhesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 0px;
`;

export const TimeLineContainer = styled.div`
  grid-area: 1/4/2/5;
`;

export const DetalhesPedidoContainer = styled.div`
  grid-area: 1/1/2/4;
`;
